document.addEventListener("DOMContentLoaded", function(){
  const preview_image_col = document.getElementById('preview_image_col');
  if (preview_image_col) {
    preview_image_col.classList.add('d-none');
  }

  function readFile(input) {
    const preview_image = document.getElementById('preview_image');
    const saved_image_col = document.getElementById('saved_image_col');
    const [file] = input.files

    if (file) {
      preview_image.src = URL.createObjectURL(file);
      preview_image_col.classList.remove('d-none');
      if (saved_image_col) {
        saved_image_col.classList.add('d-none');
      }
    }
  }

  window.readFile = readFile;
});
